import React from "react";
import { NotificationListBody } from "tsi-common-react/src/apps/customer-account/NotificationListBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.NotificationListDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <NotificationListBody {...props} />
    </PageSkeleton>
);
